module.exports = __webpack_public_path__ + "static/talona-symbol-SCAG-a4353014d5a7d0afeabd66880b191f0d.png";